import _ from "lodash";

import { Company } from "../models/company";
import { CompanyProfile, CompanyProfileInitial } from "./enums";
import { User } from "Models/user";
import { PRODUCTION_SHIPEEZI_MOVING_DEMO_COMPANY_ID } from "./constants";

export const checkIfNullAndUndefined = (value: string): string => {
  if (_.isNull(value) || _.isUndefined(value)) {
    return "";
  }

  return value;
};

export const isUserTypeAdmin = (currentUser: User | undefined) =>
  Boolean(currentUser?.typeUser === "Admin");

export const isProductionShipeeziTestCompany = (companyId: number): Boolean =>
  Boolean(companyId === PRODUCTION_SHIPEEZI_MOVING_DEMO_COMPANY_ID);

export const isRetailerPlus = (company?: Company): Boolean =>
  Boolean(company?.profile?.initials === CompanyProfile.FM);

export const isRetailer = (company?: Company): Boolean =>
  Boolean(company?.profile?.initials === CompanyProfile.SP);

export const isSupplyChain = (company?: Company): Boolean =>
  Boolean(company?.profile?.initials === CompanyProfile.SP);

export const isMoving = (company?: Company): Boolean =>
  Boolean(company?.profile?.initials === CompanyProfile.MV || isMovingAgent(company));

export const isMovingAgent = (company?: Company): Boolean =>
  Boolean(company?.profile?.initials === CompanyProfile.MA);

export const isShipmentTracking = (company?: Company): Boolean =>
  Boolean(company?.profile?.initials === CompanyProfile.ST);

export const isCompanyProfile = (company?: Company, profileInitial?: CompanyProfileInitial) => {
  return company?.profile?.initials === profileInitial;
};
